import React, { useState, useEffect } from "react";
import { Grid, IconButton, Box, Button } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { Typography } from "@mui/material";
import { toast } from "react-toastify";

const AddImageComponent = ({
  inputName,
  fileName,
  onImageChange,
  onImageDelete,
}) => {
  const [imageName, setImageName] = useState("Add image");
  const [imageFile, setImageFile] = useState(null);

  useEffect(() => {
    if (!fileName) {
      setImageName("Add image");
      return;
    }
    if (fileName instanceof File) {
      setImageName(fileName.name);
      setImageFile(fileName);
      return;
    }
    if (typeof fileName === "string") {
      let name = fileName.split("?")[0].split("/");
      if (name) {
        name = name[name.length - 1];
        setImageName(decodeURIComponent(name));
      }
    }
  }, [fileName]);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.size <= 1000 * 1024 * 1024) {
      setImageName(file.name);
      setImageFile(file);
      if (onImageChange) {
        onImageChange(file);
      }
    } else {
      toast.error("Please choose a file under 1GB.");
    }
  };

  const handleFileDelete = async () => {
    if (imageFile) {
      setImageName("Add image");
      setImageFile(null);
      if (onImageDelete) {
        await onImageDelete();
      }
      return;
    }

    if (onImageDelete) {
      try {
        await onImageDelete();
        setImageName("Add image");
        setImageFile(null);
      } catch (err) {
        console.error(`Error deleting image`, err);
      }
    }
  };

  return (
    <Box sx={{ paddingLeft: 38, borderRadius: 1 }}>
      <Grid container spacing={2} alignItems="center">
        <Grid item>
          <Button variant="contained" component="label" className="btn-primary">
            <Typography textTransform={"none"}>{imageName}</Typography>
            <input
              type="file"
              hidden
              accept="image/*"
              name={inputName}
              onChange={handleFileChange}
            />
          </Button>
        </Grid>
        <Grid item>
          <IconButton
            aria-label="delete"
            onClick={handleFileDelete}
            disabled={imageName === "Add image"}
          >
            <DeleteIcon
              color={imageName === "Add image" ? "disabled" : "error"}
            />
          </IconButton>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AddImageComponent;
